import { render, staticRenderFns } from "./UserAddPage.vue?vue&type=template&id=2fc030de&scoped=true&"
import script from "./UserAddPage.vue?vue&type=script&lang=ts&"
export * from "./UserAddPage.vue?vue&type=script&lang=ts&"
import style0 from "./UserAddPage.vue?vue&type=style&index=0&id=2fc030de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc030de",
  null
  
)

export default component.exports